module.exports = __webpack_public_path__ + "static/media/print-image.b8a2a5bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/print-image.png
// module id = 943
// module chunks = 0